<template>
  <div class="h-screen flex overflow-hidden bg-gray-50">
    <!-- Off-canvas menu for mobile -->
    <div
      v-show="open"
      class="md:hidden"
    >
      <div
        @click="open = true"
        v-show="open"
        x-transition:enter-start="opacity-0"
        x-transition:enter-end="opacity-100"
        x-transition:leave-start="opacity-100"
        x-transition:leave-end="opacity-0"
        class="fixed inset-0 z-30 transition-opacity ease-linear duration-300"
      >
        <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
      </div>
      <div class="fixed inset-0 flex z-40">
        <div
          v-show="open"
          x-transition:enter-start="-translate-x-full"
          x-transition:enter-end="translate-x-0"
          x-transition:leave-start="translate-x-0"
          x-transition:leave-end="-translate-x-full"
          class="flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white transform ease-in-out duration-300 "
        >
          <div class="absolute top-0 right-0 -mr-14 p-1">
            <button
              v-show="open"
              @click="open = false"
              class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600"
            >
              <svg
                class="h-6 w-6 text-white"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="flex-shrink-0 flex items-center px-4">
            <router-link :to="{name : 'home'}">
              <img
                src="@/assets/healthy-university-logo.png"
                class="w-24"
              />
            </router-link>
          </div>
          <div class="mt-5 flex-1 h-0 overflow-y-auto">
            <nav class="px-2">
              <router-link
                :to="{name :'home'}"
                class="group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-900 rounded-md bg-gray-100 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150"
              >
                <svg
                  class="mr-3 h-6 w-6 text-gray-500 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6"
                  />
                </svg>
                หน้าหลัก
              </router-link>

              <a
                href="#"
                class="mt-1 group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
              >
                <svg
                  class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                  />
                </svg>
                แบบทดสอบ
              </a>
              <router-link
                :to="{name: 'assessment-risk'}"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
              >
                ด้านความเสี่ยงสุขภาพ
              </router-link>
              <router-link
                :to="{name: 'assessment-whoqol'}"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
              >
                ด้านคุณภาพชีวิต
              </router-link>
              <router-link
                :to="{name: 'assessment-hplp'}"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
              >
                ด้านพฤติกรรมสร้างเสริมสุขภาพ
              </router-link>
              <a
                href="#"
                class="mt-1 group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
              >
                <svg
                  class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
                รายงาน
              </a>
              <router-link
                v-on:click.native="hideMenu"
                :to="{name: 'assessment-history.overview'}"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
              >
                ภาพรวม
              </router-link>
              <router-link
                v-on:click.native="hideMenu"
                :to="{name: 'assessment-history.risk'}"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
              >
                ด้านความเสี่ยงสุขภาพ
              </router-link>
              <router-link
                v-on:click.native="hideMenu"
                :to="{name: 'assessment-history.whoqol'}"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
              >
                ด้านคุณภาพชีวิต
              </router-link>
              <router-link
                v-on:click.native="hideMenu"
                :to="{name: 'assessment-history.hplp'}"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
              >
                ด้านพฤติกรรมสร้างเสริมสุขภาพ
              </router-link>

              <a
                @click="signOut"
                class="mt-8 mb-16 text-primary group  flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
              >

                <svg
                  viewBox="0 0 512.0053 512"
                  class="mr-3 h-5  w-5  fill-current text-gray-600 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M320 277.336c-11.7969 0-21.332 9.5585-21.332 21.332v85.336c0 11.7538-9.5586 21.332-21.336 21.332h-64v-320c0-18.2188-11.6054-34.4962-29.0547-40.5547l-6.3164-2.1133h99.3711c11.7774 0 21.336 9.578 21.336 21.336v64c0 11.7733 9.5351 21.332 21.332 21.332s21.332-9.5587 21.332-21.332v-64c0-35.2853-28.7148-64-64-64H48c-.8125 0-1.4922.3632-2.2812.4687-1.0274-.086-2.0079-.4688-3.0508-.4688C19.1367.004 0 19.1367 0 42.668v384c0 18.2188 11.6055 34.4962 29.0547 40.5548l128.3867 42.7968c4.3516 1.3438 8.6797 1.9844 13.2266 1.9844 23.5312 0 42.664-19.1367 42.664-42.668v-21.332h64c35.2852 0 64-28.7148 64-64v-85.336c0-11.7734-9.5351-21.332-21.332-21.332zm0 0" />
                  <path d="M505.75 198.254l-85.336-85.3321c-6.0976-6.1016-15.2734-7.9375-23.25-4.6328-7.957 3.3086-13.164 11.0937-13.164 19.7148v64h-85.332c-11.7774 0-21.336 9.5547-21.336 21.332 0 11.7774 9.5586 21.332 21.336 21.332H384v64c0 8.6212 5.207 16.4063 13.164 19.715 7.9766 3.3046 17.1524 1.4687 23.25-4.629l85.336-85.336c8.3398-8.3398 8.3398-21.8242 0-30.164zm0 0" />
                </svg>

                ออกจากระบบ
              </a>
            </nav>
          </div>
        </div>
        <div class="flex-shrink-0 w-14">
          <!-- Force sidebar to shrink to fit close icon -->
        </div>
      </div>
    </div>

    <!-- Static sidebar for desktop -->
    <div class="hidden md:flex md:flex-shrink-0">
      <div class="flex flex-col w-64 border-r border-gray-200 pt-5 pb-4 bg-white">
        <div class="flex items-center justify-center flex-shrink-0 px-4">
          <img
            src="@/assets/healthy-university-logo.png"
            class="w-24"
          />
        </div>
        <div class="mt-5 h-0 flex-1 flex flex-col overflow-y-auto">
          <!-- Sidebar component, swap this element with another sidebar if you like -->
          <nav class="flex-1 px-2 bg-white">
            <router-link
              :to="{name :'home'}"
              class="group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-900 rounded-md bg-gray-100 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150"
            >
              <svg
                class="mr-3 h-6 w-6 text-gray-500 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6"
                />
              </svg>
              หน้าหลัก
            </router-link>

            <a
              href="#"
              class="mt-1 group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
            >
              <svg
                class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                />
              </svg>
              แบบทดสอบ
            </a>
            <router-link
              :to="{name: 'assessment-risk'}"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
            >
              ด้านความเสี่ยงสุขภาพ
            </router-link>
            <router-link
              :to="{name: 'assessment-whoqol'}"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
            >
              ด้านคุณภาพชีวิต
            </router-link>
            <router-link
              :to="{name: 'assessment-hplp'}"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
            >
              ด้านพฤติกรรมสร้างเสริมสุขภาพ
            </router-link>
            <a
              href="#"
              class="mt-1 group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
            >
              <svg
                class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              รายงาน
            </a>
            <router-link
              :to="{name: 'assessment-history.overview'}"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
            >
              ภาพรวม
            </router-link>
            <router-link
              :to="{name: 'assessment-history.risk'}"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
            >
              ด้านความเสี่ยงสุขภาพ
            </router-link>
            <router-link
              :to="{name: 'assessment-history.whoqol'}"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
            >
              ด้านคุณภาพชีวิต
            </router-link>
            <router-link
              :to="{name: 'assessment-history.hplp'}"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
            >
              ด้านพฤติกรรมสร้างเสริมสุขภาพ
            </router-link>

            <a
              @click="signOut"
              class="mt-8 mb-16 text-primary group  flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
            >

              <svg
                viewBox="0 0 512.0053 512"
                class="mr-3 h-5  w-5  fill-current text-gray-600 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M320 277.336c-11.7969 0-21.332 9.5585-21.332 21.332v85.336c0 11.7538-9.5586 21.332-21.336 21.332h-64v-320c0-18.2188-11.6054-34.4962-29.0547-40.5547l-6.3164-2.1133h99.3711c11.7774 0 21.336 9.578 21.336 21.336v64c0 11.7733 9.5351 21.332 21.332 21.332s21.332-9.5587 21.332-21.332v-64c0-35.2853-28.7148-64-64-64H48c-.8125 0-1.4922.3632-2.2812.4687-1.0274-.086-2.0079-.4688-3.0508-.4688C19.1367.004 0 19.1367 0 42.668v384c0 18.2188 11.6055 34.4962 29.0547 40.5548l128.3867 42.7968c4.3516 1.3438 8.6797 1.9844 13.2266 1.9844 23.5312 0 42.664-19.1367 42.664-42.668v-21.332h64c35.2852 0 64-28.7148 64-64v-85.336c0-11.7734-9.5351-21.332-21.332-21.332zm0 0" />
                <path d="M505.75 198.254l-85.336-85.3321c-6.0976-6.1016-15.2734-7.9375-23.25-4.6328-7.957 3.3086-13.164 11.0937-13.164 19.7148v64h-85.332c-11.7774 0-21.336 9.5547-21.336 21.332 0 11.7774 9.5586 21.332 21.336 21.332H384v64c0 8.6212 5.207 16.4063 13.164 19.715 7.9766 3.3046 17.1524 1.4687 23.25-4.629l85.336-85.336c8.3398-8.3398 8.3398-21.8242 0-30.164zm0 0" />
              </svg>

              ออกจากระบบ
            </a>
          </nav>
        </div>
      </div>
    </div>
    <div class="flex flex-col w-0 flex-1 overflow-hidden">
      <div class="relative z-10 flex-shrink-0 flex h-16 bg-white shadow">
        <button
          @click.stop="open = true"
          class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:bg-gray-100 focus:text-gray-600 md:hidden"
        >
          <svg
            class="h-6 w-6"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h7"
            />
          </svg>
        </button>
        <div class="flex-1 px-4 flex justify-between max-w-7xl">
          <div class="flex-1 flex">

          </div>
          <div class="ml-4 flex items-center md:ml-6">
            <div>
              {{user.firstname}} {{user.lastname}}
            </div>
            <div class="ml-3 relative">
              <div>
                <button
                  @click="open = !open"
                  class="max-w-xs flex items-center text-sm rounded-full focus:outline-none focus:shadow-outline"
                >
                  <img
                    class="h-8 w-8 rounded-full"
                    src="https://www.m-culture.go.th:15005/mocbackend2561/ewt/suratthani/images/gallery/600px-Default_profile_picture_(male)_on_Facebook.jpg"
                    alt=""
                  />
                </button>
              </div>
              <div
                v-show="open"
                x-transition:enter="transition ease-out duration-100"
                x-transition:enter-start="transform opacity-0 scale-95"
                x-transition:enter-end="transform opacity-100 scale-100"
                x-transition:leave="transition ease-in duration-75"
                x-transition:leave-start="transform opacity-100 scale-100"
                x-transition:leave-end="transform opacity-0 scale-95"
                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg"
              >
                <div class="py-1 rounded-md bg-white shadow-xs">
                  <a
                    @click="signOut"
                    href="#"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                  >
                    ออกจากระบบ
                  </a>
                </div>
              </div>
            </div>
            <button
              @click="toggleMenu"
              class="p-1 ml-2"
            >
              <svg
                class=" h-3 w-3 text-gray-400 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 255 255"
              >
                <path d="M0 63.75l127.5 127.5L255 63.75z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <main
        class="flex-1 relative z-0 overflow-y-auto py-6 focus:outline-none"
        tabindex="0"
      >
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <!-- <h1 class="text-2xl font-semibold text-gray-900">Dashboard</h1> -->
        </div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <div class="py-4">
            <router-view></router-view>
          </div>
          <!-- /End replace -->
        </div>
      </main>
      <!-- <div class="text-center py-4 bg-primary w-full">
        <p class="text-white font-light px-4">
          CMU i-Heath
          เป็นลิขสิทธิ์ของโครงการพัฒนาศักยภาพการสร้างเสริมสุขภาพของบุคลากรมหาวิทยาลัยเชียงใหม่
          สำหรับการขับเคลื่อนสู่มหาวิทยาลัยสุขภาพ ไม่อนุญาตให้ลอกเลียนแบบ นำไปใช้
          หรือทำซ้ำโดยไม่ได้รับอนุญาต
        </p>
      </div> -->
    </div>
  </div>

</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      open: false
    };
  },
  async created() {
    const response = await axios({
      method: "GET",
      url: `${process.env.VUE_APP_API_URL}/me/profile`,
      headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
    });

    const user = response.data;

    this.$store.dispatch("updateUser", user);
  },
  methods: {
    toggleMenu() {
      this.open = !this.open;
    },
    signOut() {
      localStorage.clear();

      this.$router.push({ name: "home" });
    },
    hideMenu() {
      console.log("hide menu");

      this.open = false;
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  }
};
</script>
